import React from "react";
import { Button, Form, Input, InputNumber, Popconfirm, Table } from "antd"
import * as etiquetas from '../../ApplicationResources';
import Highlighter from "react-highlight-words";
import { SearchOutlined } from "@ant-design/icons";
import ModalMensajes from "../interfaz/ModalMensajes";

const EditableContext = React.createContext();

class EditableCell extends React.Component {
    getInput = () => {
        if (this.props.inputType === 'number') {
            return <InputNumber />;
        }
        return <Input />;
    };

    renderCell = ({ getFieldDecorator }) => {
        const {
            editing,
            dataIndex,
            title,
            inputType,
            record,
            index,
            children,
            ...restProps
        } = this.props;
        return (
            <td {...restProps}>
                {editing ? (
                    <Form.Item style={{ margin: 0 }}>
                        {getFieldDecorator(dataIndex, {
                            rules: [
                                {
                                    required: true,
                                    message: `Por favor ingrese ${title}`,
                                },
                            ],
                            initialValue: record[dataIndex],
                        })(this.getInput())}
                    </Form.Item>
                ) : (
                    children
                )}
            </td>
        );
    };

    render() {
        return <EditableContext.Consumer>{this.renderCell}</EditableContext.Consumer>;
    }
}

class Tabla extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            data: undefined,
            columns: undefined,
            searchText: '',
            searchedColumn: '',
            searchInput: null,
            editingKey: '',
            // Variables necesarias para el componente ModalMensajes.jsx
            modalTipoMensaje: "",
            modalMensaje: "",
            modalAbrir: false,
            tipoModal: 0 // Almacena el último tipo de modal ejecutado o mostrado (revisar ApplicationResources: CONSTANTE_MODAL_TIPO_MODAL_MENSAJE_SIMPLE, etc...)
        }
    }

    transformarColumnas = async () => {
        if (this.props.columns) {
            let columns = []

            // Iteramos las columnas definidas
            await this.props.columns.map(item => {
                // Si existe un elemento que tendrá la funcionalidad de búsqueda, se agrega la propiedad
                let json = item.searchable ? {
                    title: item.title,
                    dataIndex: item.dataIndex,
                    editable: item.editable,
                    ellipsis: item.ellipsis,
                    ...this.getColumnSearchProps(item.dataIndex)
                } : {
                    title: item.title,
                    dataIndex: item.dataIndex,
                    editable: item.editable,
                    ellipsis: item.ellipsis,
                }

                columns.push(json)
            })

            columns.push(
                {
                    title: 'Operación',
                    dataIndex: 'operation',
                    render: (text, record) => {
                        const { editingKey } = this.state;
                        const editable = this.isEditing(record);
                        return editable ? (
                            <span>
                                <div style={{ marginBottom: '10px' }}>
                                    <EditableContext.Consumer>
                                        {form => (
                                            <a
                                                onClick={() => this.save(form, record.key)}
                                                style={{ marginRight: 8 }}
                                            >
                                                Guardar
                                            </a>
                                        )}
                                    </EditableContext.Consumer>
                                </div>
                                <div>
                                    <Popconfirm title="¿Estás seguro?" onConfirm={() => this.cancel(record.key)}>
                                        <a>Cancelar</a>
                                    </Popconfirm>
                                </div>
                            </span>
                        ) : (
                            <>
                                <div style={{ marginBottom: '10px' }}>
                                    <a disabled={editingKey !== ''} onClick={() => this.edit(record.key)}>
                                        Editar
                                    </a>
                                </div>
                                <div>
                                    <Popconfirm title="¿Estás seguro que deseas eliminar?" onConfirm={() => this.handleDelete(record.key)}>
                                        <a disabled={editingKey !== ''}>Eliminar</a>
                                    </Popconfirm>
                                </div>
                            </>
                        );
                    },
                }
            )

            const col = columns.map(col => {
                if (!col.editable) {
                    return col;
                }
                return {
                    ...col,
                    onCell: record => ({
                        record,
                        inputType: 'text',
                        dataIndex: col.dataIndex,
                        title: col.title,
                        editing: this.isEditing(record),
                    }),
                };
            })

            // Actualizamos el estate
            this.setState({
                columns: col
            })
        }
    }

    componentDidMount() {
        this.transformarColumnas()
        this.setState({ data: this.props.data, columns: this.props.columns });
    }

    componentDidUpdate(prevProps) {
        if (this.props.data !== prevProps.data) {
            this.transformarColumnas()
            this.setState({ data: this.props.data });
        }
    }

    handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();

        this.setState({
            searchText: selectedKeys[0],
            searchedColumn: dataIndex
        })
    }

    handleReset = (clearFilters) => {
        clearFilters();

        this.setState({
            searchText: ''
        })
    };

    getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
            <div
                style={{
                    padding: 8,
                }}
                onKeyDown={(e) => e.stopPropagation()}
            >
                <Input
                    ref={this.state.searchInput}
                    placeholder={`Buscar ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{
                        marginBottom: 8,
                        display: 'block',
                    }}
                />
                <Button
                    type="primary"
                    onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                    icon={<SearchOutlined />}
                    size="small"
                    style={{
                        width: 90,
                    }}
                >
                    Buscar
                </Button>
                <Button
                    onClick={() => clearFilters && this.handleReset(clearFilters)}
                    size="small"
                    style={{
                        width: 90,
                    }}
                >
                    Limpiar
                </Button>
            </div>
        ),
        filterIcon: (filtered) => (
            <SearchOutlined
                style={{
                    color: filtered ? '#1677ff' : undefined,
                }}
            />
        ),
        onFilter: (value, record) =>
            record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
        onFilterDropdownOpenChange: (visible) => {
            if (visible) {
                setTimeout(() => this.state.searchInput.current?.select(), 100);
            }
        },
        render: (text) =>
            this.state.searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{
                        backgroundColor: '#ffc069',
                        padding: 0,
                    }}
                    searchWords={[this.state.searchText]}
                    autoEscape
                    textToHighlight={text ? text.toString() : ''}
                />
            ) : (
                text
            ),
    });

    isEditing = record => record.key === this.state.editingKey;

    handleDelete = key => {
        const dataSource = [...this.state.data];
        const elemento = dataSource.find(item => item.key === key)
        
        // Se el elemento contiene más de 1 campo, significa que se encuentra lleno
        if(Object.keys(elemento).length > 1) {
            this.props.functionDelete(elemento).then(response => {
                if (response.data && response.data.executed) {
                    this.setState({ data: dataSource.filter(item => item.key !== key) });

                    this.modalAbrir(etiquetas.CONSTANTE_MODAL_TIPO_MENSAJE_NOTIFICACION, "Se eliminó correctamente.", etiquetas.CONSTANTE_MODAL_TIPO_MODAL_MENSAJE_SIMPLE);
                } else
                    this.modalAbrir(etiquetas.CONSTANTE_MODAL_TIPO_MENSAJE_ERROR, "Ocurrió un error al ejecutar la operación. Por favor vuelva a intentarlo más tarde.", etiquetas.CONSTANTE_MODAL_TIPO_MODAL_MENSAJE_SIMPLE);
            }).catch(err => {
                console.log(err)
                this.modalAbrir(etiquetas.CONSTANTE_MODAL_TIPO_MENSAJE_ERROR, "Ocurrió un error al ejecutar la operación. Por favor vuelva a intentarlo más tarde.", etiquetas.CONSTANTE_MODAL_TIPO_MODAL_MENSAJE_SIMPLE);
            })
        } else
            this.setState({ data: dataSource.filter(item => item.key !== key) });
    };

    handleAdd = () => {
        try {
            const { data } = this.state;
            let ultimo = undefined

            data.map(item => {
                ultimo = Object.assign(item)
            })

            const newData = {
                key: ultimo.key + 1,
            };

            this.setState({
                data: [...data, newData],
            });
        } catch (err) {
            console.log(err)
        }
    };

    edit(key) {
        this.setState({ editingKey: key });
    }

    cancel = () => {
        this.setState({
            editingKey: ''
        })
    };

    save(form, key) {
        form.validateFields((error, row) => {
            if (error) {
                return;
            }

            this.props.functionSave(row).then(response => {
                if (response.data && response.data.executed) {
                    const newData = [...this.state.data];
                    const index = newData.findIndex(item => key === item.key);
                    if (index > -1) {
                        const item = newData[index];
                        newData.splice(index, 1, {
                            ...item,
                            ...row,
                        });
                        this.setState({ data: newData, editingKey: '' });
                    } else {
                        newData.push(row);
                        this.setState({ data: newData, editingKey: '' });
                    }
                    this.modalAbrir(etiquetas.CONSTANTE_MODAL_TIPO_MENSAJE_NOTIFICACION, "Se actualizó correctamente.", etiquetas.CONSTANTE_MODAL_TIPO_MODAL_MENSAJE_SIMPLE);
                } else
                    this.modalAbrir(etiquetas.CONSTANTE_MODAL_TIPO_MENSAJE_ERROR, "Ocurrió un error al ejecutar la operación. Por favor vuelva a intentarlo más tarde.", etiquetas.CONSTANTE_MODAL_TIPO_MODAL_MENSAJE_SIMPLE);
            }).catch(err => {
                console.log(err)
                this.modalAbrir(etiquetas.CONSTANTE_MODAL_TIPO_MENSAJE_ERROR, "Ocurrió un error al ejecutar la operación. Por favor vuelva a intentarlo más tarde.", etiquetas.CONSTANTE_MODAL_TIPO_MODAL_MENSAJE_SIMPLE);
            })
        });
    }

    /**
     * Función que permite cerrar el modal
     */
    modalCerrar = () => {
        this.setState({ modalAbrir: false });
    }

    /**
     * Función que permite abrir el modal
     * @param {*} tipoMensaje Especificar el tipo de mensaje a desplegar (para saber qué tipo de imagen desplegar)
     * @param {*} mensaje Especificar el mensaje a desplegar
     * @param {*} tipoModal Elige el tipo de modal a desplegar (mensaje simple, decisión, etc...revisar el componente para mayor especificación)
     */
    modalAbrir = (tipoMensaje, mensaje, tipoModal) => {
        this.setState({
            modalTipoMensaje: tipoMensaje,
            modalMensaje: mensaje,
            modalAbrir: true,
            tipoModal: tipoModal
        });
    }

    render() {
        const components = {
            body: {
                cell: EditableCell,
            },
        };

        return (
            <>
                <div style={{marginBottom:'15px', marginTop: '15px'}}>
                    <hr />
                    <h1 style={{textAlign:'center'}}>{this.props.title ? this.props.title : ""}</h1>
                    <Button onClick={this.handleAdd} type="primary" style={{ marginBottom: 16 }}>
                        Agregar registro
                    </Button>

                    <EditableContext.Provider value={this.props.form}>
                        <Table
                            pagination={{ pageSize: 5 }}
                            components={components}
                            rowClassName={() => 'editable-row'}
                            bordered
                            scroll={{ x: 1300 }}
                            dataSource={this.state.data}
                            columns={this.state.columns}
                        />
                    </EditableContext.Provider>
                    <ModalMensajes
                        tipoMensaje={this.state.modalTipoMensaje}
                        mensaje={this.state.modalMensaje}
                        abrirModal={this.state.modalAbrir}
                        cerrarModal={this.modalCerrar}
                        tipoModal={this.state.tipoModal}
                    />
                    <hr />
                </div>
            </>
        )
    }
}

export default Form.create({ name: 'formTabla' })(Tabla)